import React from 'react'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import { Form, Formik } from 'formik'
import { useSelector } from 'react-redux'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import {
  Box,
  Link,
  Typography,
  makeStyles,
  IconButton,
  InputAdornment,
} from '@material-ui/core'

import { SECONDARY } from 'app/constants/button'
import { Routes } from 'app/services/routeService/routeService'

import LabelInput from 'app/componentV4/Labels/LabelInput'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import PanelsIllustrationMSG from 'app/componentV4/Panels/IllustrationMSG'

const useStyles = makeStyles({
  button: {
    '&.MuiOutlinedInput-root': {
      height: '48px !important',
    },
  },
  input: {
    '&.MuiOutlinedInput-root': {
      height: '48px !important',
    },
  },
})

const VerificationWithPassword = (props) => {
  const {
    email = '',
    onSubmit = () => {},
    isLoading,
    onBack = () => {},
  } = props
  const classes = useStyles()
  const login = useSelector(({ auth }) => auth.login)

  return (
    <PanelsIllustrationMSG isClickBack={true} onBack={() => onBack()}>
      <div className="flex justify-center items-center h-full">
        <div className="w-full">
          {/* Header */}
          <Box className="rounded-8 py-5 px-10 bg-primary-200 my-10">
            <Typography className="text-16 text-primary text-center">
              {'Signing In with'}
            </Typography>
            <Typography className="text-16 font-500 text-primary text-center break-all">
              {email}
            </Typography>
          </Box>

          <div className="flex items-center my-10">
            <div className="flex-1 border-t border-primary-350"></div>
            <Typography className="text-16 text-primary-300 text-center mx-5">
              {'Enter your password'}
            </Typography>
            <div className="flex-1 border-t border-primary-350"></div>
          </div>

          <Formik
            initialValues={{
              password: '',
              isShowPassword: false,
            }}
            enableReinitialize={false}
            validateOnBlur={false}
            validationSchema={Yup.object({
              password: Yup.string().required('This field is required'),
              remember: Yup.bool(),
              isShowPassword: Yup.bool(),
            })}
            onSubmit={async (values) => {
              await onSubmit(values)
            }}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              setFieldValue,
            }) => (
              <Form>
                <LabelInput
                  label={'Enter Password'}
                  required
                  className="w-full mb-0"
                >
                  <SimpleInput
                    autoFocus={true}
                    className={classes.input}
                    type={values.isShowPassword ? 'text' : 'password'}
                    id="password-input"
                    name="password"
                    placeholder={'Enter Password'}
                    value={values.password}
                    size="medium"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    inputProps={{
                      'aria-label': 'Password sign in',
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() =>
                            setFieldValue(
                              'isShowPassword',
                              !values.isShowPassword,
                            )
                          }
                        >
                          {values.isShowPassword ? (
                            <Visibility
                              fontSize="small"
                              className="text-grey-200"
                            />
                          ) : (
                            <VisibilityOff
                              fontSize="small"
                              className="text-grey-200"
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password && errors.password}
                  />
                </LabelInput>

                {/* Continue button */}
                <div className="flex justify-center mt-10">
                  <ContainedButton
                    type="submit"
                    id="continue-password-btn"
                    color={SECONDARY}
                    className="w-full h-48"
                    disabled={isLoading || login.isSubmitting}
                    isLoading={isLoading || login.isSubmitting}
                  >
                    {'Continue'}
                  </ContainedButton>
                </div>
              </Form>
            )}
          </Formik>

          <div className="my-10 text-center">
            <Link
              className="p-0 text-primary-300 text-14 font-400 normal-case hover:bg-transparent text-nowrap"
              href={Routes.forgotPassword()}
            >
              {'Forget Password?'}
            </Link>
          </div>
        </div>
      </div>
    </PanelsIllustrationMSG>
  )
}

VerificationWithPassword.propTypes = {
  onBack: PropTypes.func,
  email: PropTypes.string,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default VerificationWithPassword
